import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { setLanguage } from "../../../redux/slices/languageSlice";
import './languageSelector.scss'

const LanguageSelector: React.FC = () => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state: RootState) => state.language.language);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const languages = [
    { code: "en", label: "English" },
    { code: "ru", label: "Русский" },
  ];

  const handleLanguageChange = (lang: string) => {
    dispatch(setLanguage(lang));
    setIsOpen(false);
  };

  const current = languages.find(lang => lang.code === currentLanguage);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="language-selector" ref={dropdownRef}>
      <button onClick={() => setIsOpen(!isOpen)}>
        {current?.label}
      </button>
      {isOpen && (
        <div className="language-selector__dropdown">
          {languages.map(lang => (
            <p key={lang.code} onClick={() => handleLanguageChange(lang.code)}>
              {lang.label}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
